module.exports = __webpack_public_path__ + "img/ad02.02df2dec.png";